import {Application} from "./Application";
import {ExclaimApplication} from "./ExclaimApplication";

// Initialize the "EX" structure where a bunch of common exclaim stuff is stored
export const EX: Application = new ExclaimApplication();

// Avoid using this global in code, but it's still needed by some bits of
// code (e.g.: PersonMatch.js), and it's handy for debugging to get at the
// application objects.
declare global {
    // noinspection JSUnusedGlobalSymbols
    interface Window {
        EX: Application;
    }
}
if (globalThis?.window !== undefined) {
    globalThis.window.EX = EX;
}
